import React from "react";
import styles from "../Signin.module.css";

interface LoginCardProps {
  icon: string;
  title: string;
  description: string;
}

const LoginCard: React.FC<LoginCardProps> = ({ icon, title, description }) => {
  return (
    <div className={styles.card}>
      <div className={styles.cardIcon}>
        <span className="material-symbols-outlined" style={{ fontSize: "24px" }}>
          {icon}
        </span>
      </div>
      <div className={styles.cardContent}>
        <h3>{title}</h3>
        <p>{description}</p>
      </div>
    </div>
  );
};

export default LoginCard;
